export const validateObj = (tab = 'background') => {
  return {};
};

export const getUnderwritingBR = (values = {}, tab = 'background') => {
  const brMapping = {};
  return brMapping[tab] || null;
};
